module.exports = __webpack_public_path__ + "static/img/sharp.85b80bdf.png";